<template>
  <div class="register-view">
    <register-form />
  </div>
</template>

<script>

  import RegisterForm from 'brave-authentication/components/register'
  export default {
    name: 'RegistrationView',
    components: {
      'register-form': RegisterForm
    }
  }
</script>





// WEBPACK FOOTER //
// apps/www.bravenet.com/src/views/register.vue